const API_V2 = {
  CONTRACT_DRAFT: "/v2/contracts/draft/{contractId}/",
  CONTRACT_MEETING: "/v2/contracts/{contractId}/meeting",
  CONTRACT_IT_IMPORTANT_DOCUMENT_REQUIRED_COND_CHECK:
    "/v2/contracts/{contractId}/it-important-document-required-cond-check",

  CONTRACT_DOCUMENT: "/v2/contract-documents?contract_id={contractId}",
  CONTRACT_DOCUMENT_DETAIL: "/v2/contract-documents/{contractDocumentId}",
  CONTRACT_DOCUMENT_T0_DISPLAY: "/v2/contract-documents/{contractDocumentId}/document-to-display",
  CONTRACT_DOCUMENT_CREATE: "/v2/contract-documents",
  CONTRACT_DOCUMENT_BATCH_DELETE: "/v2/contract-documents/batch-delete",

  UPLOAD_TO_BLOCKCHAIN: "/v2/upload/register-document-to-blockchain",
  UPLOAD_TO_BUCKET: "/v2/upload/upload-to-bucket",

  STATE_MACHINE_SEND_ACTION: "/v2/state-machine/send-event",
  STATE_MACHINE_BATCH_SEND_DOCUMENT: "/v2/state-machine/batch-send-document",
  STATE_MACHINE_BATCH_SEND_EVENT: "/v2/state-machine/batch-send-event",

  IMPORT_CHECK_CONTRACT_CSV: "/v2/import/check-contract-csv",
  IMPORT_CONTRACT: "/v2/import/import-contract",

  COMPANY_BIZ_WORKFLOWS: "/v2/document-workflows/biz-workflow/",
  COMPANY_BIZ_WORKFLOWS_ID: "/v2/document-workflows/biz-workflow/{id}",
  COMPANY_WORKFLOWS: "/v2/document-workflows",
  COMPANY_WORKFLOWS_ID: "/v2/document-workflows/{id}",
  CONTRACT_TOKEN: "/v2/contracts/token/",
  CONTRACT_BUSINESS: "/v2/contracts/business-contract/{contractId}",
  CORPORATE_HOUSING_CONTRACT: "/v2/contracts/corporate-housing-contract/{contractId}",
  RESEND_API: "v2/contracts/resend/contractor/{contractId}",

  OWNER_AGENCY_CONTRACT: "/v2/contracts/owner-agency-contract/{contractId}",
  COLLECTION_AGENCY_CONTRACT: "/v2/contracts/collection-agency-contract/{contractId}",
  OWNER_AGENCY_UPDATE_OPTION_SIGN: "/v2/contract-documents/update-option-sign",
  RESEND_EMAIL_OWNER: "/v2/contract-documents/resend-email-owner",

  COMPANY_UPDATE_OTHER_COMPANY: "/v2/company/update-other-company",

  DOWNLOAD: "/v2/download/{hash}/",
  DOWNLOAD_USER: "/v2/download/user/{hash}/",
  DOWNLOAD_NON_ACCOUNT: "/v2/download/non-account/{hash}/",

  SEND_DOCUMENT: "/v2/contracts/{contractId}/documents/send/",

  BLC_REGISTER: "/v2/blc/documents/register",
  BLC_DOWNLOAD: "/v2/blc/documents/download",

  CONTRACT_VIDEO_RECORDS: "/v2/contracts/video-records-metadata/{contractId}",
  DOWNLOAD_VIDEO_RECORD: "/v2/contracts/download-video-record",
}

export default API_V2
